document.addEventListener("DOMContentLoaded", function () {
  const sliderThumbnail = new Swiper('.product-offer__nav-slider', {
    loop: false,
    slidesPerView: 4.5,
    spaceBetween: 4,
    watchSlidesProgress: true,
    breakpoints: {
      581: {
        slidesPerView: 6.55,
        spaceBetween: 8,
      }
    }
  });

  const sliderProdMain = new Swiper('.product-offer__main-slider', {
    spaceBetween: 12,
    slidesPerView: 1.09,
    loop: false,
    thumbs: {
      swiper: sliderThumbnail
    },
    navigation: {
      nextEl: '.swiper-button-next-button',
      prevEl: '.swiper-button-prev-button',
    },
    breakpoints: {
      581: {
        slidesPerView: 1,
      }
    }
  });
});

// form
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');

  if (!form) return;

  const hasSubscriptionSelector =
    form.dataset.subscriptionSelector === 'true';

  const submitBtn = form.querySelector('#buy-now');

  // Subscription layout
  let quantityInput;

  if (hasSubscriptionSelector) {
    const cards = form.querySelectorAll('.product-offer__option');
    const sellingPlanInput = form.querySelector('#selected-selling-plan');
    quantityInput = form.querySelector('#quantity');
    const btnPrice = form.querySelector('.product-offer__btn-price');
    const btnCompare = form.querySelector('.product-offer__btn-compare');

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        cards.forEach(item => item.classList.remove('selected'));
        card.classList.add('selected');

        const sellingPlanId = card.dataset.sellingPlan;
        const selectedPrice = card.dataset.buttonPrice;
        const selectedCompare = card.dataset.buttonCompare;
        const selectedQuantity = card.dataset.quantity || 1;

        if (quantityInput) {
          quantityInput.value = selectedQuantity;
        }

        if (sellingPlanInput) {
          if (sellingPlanId) {
            sellingPlanInput.value = sellingPlanId;
            sellingPlanInput.disabled = false;
          } else {
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;
          }
        }

        if (btnPrice) {
          btnPrice.textContent = selectedPrice || '';
        }

        if (btnCompare) {
          btnCompare.textContent = selectedCompare || '';
          btnCompare.style.display = selectedCompare ? '' : 'none';
        }
      });
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    submitBtn?.classList.add('el-loading');
    submitBtn?.setAttribute('disabled', true);

    try {
      // Subscription layout updates quantity before submit
      if (hasSubscriptionSelector) {
        const selectedCard = form.querySelector('.product-offer__option.selected');

        if (quantityInput && selectedCard) {
          quantityInput.value = selectedCard.dataset.quantity || 1;
        }
      }

      const formData = new FormData(form);

      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const result = await response.json();

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && result.sections) {
        cartDrawer.renderContents(result);
        cartDrawer.classList.remove('is-empty');

        setTimeout(() => {
          cartDrawer.classList.add('active');

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 100);
      }

      if (!hasSubscriptionSelector) {
        setTimeout(() => {
          cartDrawer?.classList.add('active');

          const drawer = document.querySelector('cart-drawer');

          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }, 100);
      }

    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      submitBtn?.classList.remove('el-loading');
      submitBtn?.removeAttribute('disabled');
    }
  });
});

// video slider
const swiperProdVideoSlider = new Swiper('.product-offer__slider-contents', {
  loop: true,
  slidesPerView: 2.2,
  spaceBetween: 12,
  pagination: {
    el: '.prod-vid-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: `.swiper-button-next-prod-vid`,
    prevEl: `.swiper-button-prev-prod-vid`,
    enabled: true,
  },
  breakpoints: {
    581: {
      slidesPerView: 3,
      spaceBetween: 14,
      loop: false,
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll('.product-offer__slider-item-inner');

  videoItems.forEach(function (item) {
    const container = item.querySelector('.product-offer__slider-item-inner-container');
    const video = container.querySelector('.custom-video');
    const playButton = container.querySelector('.product-offer__slider-play-button');

    playButton.addEventListener('click', function (e) {
      e.stopPropagation();
      video.play();
      playButton.style.display = 'none';
    });

    video.addEventListener('click', function () {
      if (!video.paused) {
        video.pause();
        playButton.style.display = 'block';
      }
    });
  });
});

// sticky button
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.el-site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});